import { Component, OnInit, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { AccountConfigService } from './../../../../../services/account-config/account-config.service';
import { SessionService } from 'libs/angular-core/src/lib/account/services/session/session.service';

@Component({
  selector: 'ags-popup-habilitation-caces-ac',
  templateUrl: './popup-habilitation-caces-ac.component.html',
  styleUrls: ['./popup-habilitation-caces-ac.component.scss']
})
export class PopupHabilitationCacesAcComponent implements OnInit {
  @HostBinding('class') themeFlag = 'account-theme';
  public _infocategorie: any;
  public infohabilitation: any;
  public _config: any;
  public categorie: any;
  public generatedCertif: boolean;

  @Input('infocategorie')
  set _infoCategorie(value: any) {
    if (value) {
      this._infocategorie = value;
    }
  }

  @Input()
  set config(value: any) {
    if (value) {
      this._config = value;
    }
  }

  @Input('infohabilitation')
  set _infoHabilitation(value: any) {
    if (value) {
      this.infohabilitation = value;
    }
  }

  @Output() public close = new EventEmitter<any>();

  constructor(private accountConfigService: AccountConfigService, private sessionService: SessionService) {}

  ngOnInit() {
    this.generatedCertif = this._infocategorie.certificat ? true : false;
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.categorie = Object.assign({}, this._infocategorie.value);
  }

  getNote(prop, idNote) {
    const notes = (this.infohabilitation.notes || []).filter(e => Number(e.id) === Number(idNote));
    return notes.length ? notes[0][prop] : '';
  }

  getIdCategorie(prop, idCat) {
    const cat = (this.infohabilitation.categories || []).filter(e => Number(e.id) === Number(idCat));
    return cat.length ? cat[0][prop] : '';
  }

  // Valider les modifications
  public valider() {
    // Si on réussit la catégorie on génère une certification
    if (!this.generatedCertif && this.categorie.resultat === 'REUSSITE') {
      this.sessionService
        .generateCertif(this.infohabilitation.idSession, Number(this._infocategorie.key))
        .subscribe(res => {
          const certifData: any = res;
          this.categorie.certificat = certifData.certificat.code;
          const categorie = this.categorie;
          this.close.emit({
            categorie,
            key: this._infocategorie.key,
            bCertificat: true,
            certificat: certifData.certificat
          });
        });
    } else {
      const categorie = this.categorie;
      this.close.emit({ categorie, key: this._infocategorie.key, bCertificat: false });
    }
  }
}
